module.exports = __webpack_public_path__ + "static/media/enterprise-presentation.d020f8b3.png";